import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as s, openBlock as l, normalizeClass as d, createElementVNode as i } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSalesforceGlyph",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, n = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ i("rect", {
  width: "24",
  height: "24",
  rx: "2",
  fill: "#00A1E0"
}, null, -1), f = /* @__PURE__ */ i("path", {
  d: "M10.323 6.419a3.637 3.637 0 0 1 2.536-1.011c1.32 0 2.472.683 3.085 1.698a4.543 4.543 0 0 1 1.744-.344C20.07 6.762 22 8.57 22 10.8c0 2.231-1.93 4.04-4.312 4.04-.285 0-.57-.027-.849-.08-.54.896-1.57 1.5-2.751 1.5-.494 0-.962-.106-1.379-.295C12.162 17.161 10.886 18 9.4 18c-1.549 0-2.868-.91-3.375-2.186a3.54 3.54 0 0 1-.686.067C3.495 15.88 2 14.479 2 12.749c0-1.16.672-2.172 1.67-2.713a3.368 3.368 0 0 1-.32-1.433c0-1.99 1.739-3.602 3.884-3.602 1.26 0 2.38.556 3.089 1.418Z",
  fill: "#fff"
}, null, -1), h = [
  _,
  f
];
function m(e, p, r, u, g, a) {
  return l(), s("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--salesforce-glyph"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Salesforce Glyph",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, n);
}
const w = /* @__PURE__ */ o(c, [["render", m]]);
export {
  w as default
};
//# sourceMappingURL=salesforce-glyph.js.map
